import React from 'react'

export default class DataSourcesBuilderColumns extends React.Component {
  constructor(props) {
    super(props)
  };

  render() {
    if (this.props.activeTab === 'columns') {
      return (
        <div className="data-table report-table chart-wrapper" style={{ width: '80%' }}>
          <div className="table container data-source-columns" style={{ margin: 'auto', border: '1px solid #dddddd' }}>
            {this.renderTableHead()}
            {this.renderTableBody()}
          </div>
        </div>
      );
    } else { return null }
  };

  renderTableHead() {
    return (
      // <thead>
        <div style={{ backgroundColor: 'white' }} className="row table-head-wrapper">
        <div className="col-md table-header">{I18n.t('column')}</div>
        <div className="col-md table-header">{I18n.t('data_type')}</div>
        <div className="col-md table-header">{this.props.data_source.system_data ? I18n.t('segment_on') : I18n.t('date_format')}</div>
        <div className="col-md table-header">{ I18n.t('status')}</div>
        </div>
      // </thead>
    )
  };

  renderTableBody() {
    var rows = this.props.data_source.source_details.map((detail, idx) => {
      return (
        <div key={detail.data_column_name} style={idx % 2 === 1 ? { backgroundColor: 'white' } : null} className="row data-source-column">
          <div className="col-md column-detail">{!this.props.data_source.system_data  ? detail.data_column_name : I18n.t(detail.data_column_name)}</div>
          {
            this.props.data_source.system_data 
            ?
              <div className="col-md column-detail">{detail.data_type === 'date' ? I18n.t('date_word') : I18n.t(detail.data_type)}</div>
            :
            <div className="col-md adjust-left-align"> 
              <div className="form-group data-type-input-wrapper">
                <select className='form-control' value={detail.data_type ? detail.data_type : ''} onChange={(e) => this.props.onChangeSourceDetail(e.target.value, 'data_type', detail.data_column_name)}>
                  <option value="" disabled></option>
                  <option value="date">{I18n.t('select_date')}</option>
                  {/* <option value="time">{I18n.t('select_time')}</option> */}
                  <option value="currency">{I18n.t('currency')}</option>
                  <option value="integer">{I18n.t('integer')}</option>
                  <option value="percent">{I18n.t('percent')}</option>
                  <option value="character">{I18n.t('character')}</option>
                </select>
              </div>
            </div>
          }
          {
            !this.props.data_source.system_data
            ?
              <div className="col-md adjust-left-align">
              {this.renderDateTimeFormats(detail)}
            </div>
            :
              <div className="col-md column-detail adjust-left-align">
              {this.renderSegmentOn(detail)}
            </div>
          }
          <div className="col-md adjust-left-align">
            {
              this.renderStatus(detail)
            }
          </div>
        </div>
      )
    })
    return (
      <div>
        {rows}
      </div>
    );
  };

  renderDateTimeFormats(detail) {
    if(detail.data_type === 'date'){
      var options = this.buildOptions()
      return (
        <div className="form-group data-type-input-wrapper">
          <select className='form-control' value={detail.date_format ? detail.date_format : ''} onChange={(e) => this.props.onChangeSourceDetail(e.target.value, 'date_format', detail.data_column_name)}>
            <option value="" disabled></option>
            <option value='%B/%Y' >mmmm/yyyy (e.g. January/2016)</option>
            {options}
          </select>
        </div>
      );
    }
  };

  renderStatus(detail){
    return(
      <div className="form-group data-type-input-wrapper">
        {/* <label>{I18n.t('status')}</label>
        <br /> */}
        <select
          id="status"
          name="room_type[status]"
          value={detail.status ? detail.status : ''}
          onChange={e => this.props.onChange(e.target.value, 'status', detail.id)}
          className="form-control">
          <option value="enabled">{I18n.t('enabled')}</option>
          <option value="disabled">{I18n.t('Disabled')}</option>
        </select>
      </div>
    );
  };

  renderSegmentOn(detail){
    return(
      <div className="col-md">{detail.segment_on_model ? `${detail.segment_on_model}/${detail.segment_on_column.toLowerCase().replace(/_/g, " ").split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ')}` : I18n.t('na')}</div>
    )
  }

  buildOptions() {
    return Object.keys(this.props.date_formats).map(format => <option key={format} value={[format]} >{this.props.date_formats[format]}</option>)
  };

};